import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CmsService } from '@spartacus/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-endasure-value-disclaimer',
  templateUrl: './endasure-value-disclaimer.component.html',
  styleUrls: ['./endasure-value-disclaimer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EndasureValueDisclaimerComponent {
  privacyNotice: any;
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly dialogRef: MatDialogRef<EndasureValueDisclaimerComponent>, private readonly cmsService: CmsService) { }
  accept() {
    this.dialogRef.close(true);
  }
  ngOnInit() {
    this.cmsService.getComponentData('privayStatementNA').pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        this.privacyNotice = data.content;
      }
    })
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
